import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Text from 'shopper/components/Text';

const SearchQuerySuggestedCorrectionTooltip = ({
  children,
  className,
  ...rest
}) => (
  <div
    className={twMerge(
      'relative flex w-max max-w-[490%] cursor-pointer',
      className
    )}
    {...rest}
  >
    <Box className="bg-success-300 px-4 py-2 dark:bg-success-300">
      <div className="relative flex justify-between">
        <Text className="text-neutral-high-100 dark:text-neutral-high-200">
          {children}
        </Text>
      </div>
    </Box>
    <div className="absolute -top-px left-4 rotate-45 border-2 border-t-0 border-success-300 border-r-transparent" />
  </div>
);

SearchQuerySuggestedCorrectionTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default SearchQuerySuggestedCorrectionTooltip;
